import styled from 'styled-components';

export const TitleStyled = styled.h1`
    font-size: 24px;
    font-weight: ${(props) => props.theme.fontWeight.semiBold};
    line-height: 1.5;
    color: ${(props) => props.theme.colors.text};
    margin: 20px 0 20px;
`;
